import React, { useState, useContext } from "react";
import styled from "styled-components";
import { Link, LinkContainer, OverlayTrigger, IfPermitted, RelativeTime } from "components/common";
import { Button, DropdownButton, MenuItem, BootstrapModalConfirm } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import ForwarderForm from "./ForwarderForm";
import ForwardersContext from "./ForwardersContext";
import { ForwardersActions } from "../stores/ForwardersStore";
import ForwarderStateBadge from "../states/ForwarderStateBadge";
import ForwarderMetricContainer from "../metrics/ForwarderMetricContainer";
const StyledBadge = styled.div`
  & > .label {
    display: block;
    line-height: inherit;
  }
`;
const StyledButton = styled(Button)`
  padding: 0 15px;
`;
const ForwarderEntry = ({ forwarder, inputProfile = void 0 }) => {
  const { id, title, description, hostname, version, last_seen_at: lastSeenAt } = forwarder;
  const [showForwarderDeleteModal, setShowForwarderDeleteModal] = useState(false);
  const [showRemoveConfigModal, setShowRemoveConfigModal] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { getForwarderContext } = useContext(ForwardersContext);
  const { state: forwarderState } = getForwarderContext(id);
  const _openConfirmation = () => setShowForwarderDeleteModal(true);
  const _closeConfirmation = () => setShowForwarderDeleteModal(false);
  const _openRemoveConfirmation = () => setShowRemoveConfigModal(true);
  const _closeRemoveConfirmation = () => setShowRemoveConfigModal(false);
  const _onDelete = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_DELETED, {
      app_pathname: "forwarder",
      app_section: "input-profile"
    });
    ForwardersActions.delete(id).then(() => {
      _closeConfirmation();
    });
  };
  const _onRemoveConfiguration = () => {
    ForwardersActions.removeConfiguration(forwarder).then(() => _closeRemoveConfirmation());
  };
  const maybeClippedDescription = description && description.length > 35 ? `${description.slice(0, 35)}\u2026` : description;
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.details(id) }, title)), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    OverlayTrigger,
    {
      overlay: /* @__PURE__ */ React.createElement(React.Fragment, null, "Last seen ", /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: lastSeenAt })),
      placement: "top"
    },
    /* @__PURE__ */ React.createElement(StyledBadge, null, /* @__PURE__ */ React.createElement(ForwarderStateBadge, { forwarderId: forwarder.id }))
  )), /* @__PURE__ */ React.createElement("td", null, description === maybeClippedDescription ? description : /* @__PURE__ */ React.createElement(OverlayTrigger, { overlay: description, placement: "top" }, /* @__PURE__ */ React.createElement("span", null, maybeClippedDescription))), /* @__PURE__ */ React.createElement("td", null, hostname), /* @__PURE__ */ React.createElement("td", null, version || "N/A"), /* @__PURE__ */ React.createElement("td", null, inputProfile ? /* @__PURE__ */ React.createElement(Link, { to: ForwarderRoutes.PROFILE.details(inputProfile.id) }, inputProfile.title) : "No input profile"), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(ForwarderMetricContainer, { forwarderId: forwarder.id })), /* @__PURE__ */ React.createElement("td", null, !inputProfile ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:edit" }, /* @__PURE__ */ React.createElement(LinkContainer, { to: ForwarderRoutes.configure(id) }, /* @__PURE__ */ React.createElement(StyledButton, { bsSize: "xsmall", bsStyle: "primary" }, "Configure"))), forwarderState && forwarderState !== "CONNECTED" && /* @__PURE__ */ React.createElement(React.Fragment, null, "\xA0", /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:delete" }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "danger", onClick: _openConfirmation }, "Delete")))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:edit" }, /* @__PURE__ */ React.createElement(ForwarderForm, { forwarder, buttonBsSize: "xsmall", buttonBsStyle: "primary" })), "\xA0", /* @__PURE__ */ React.createElement("span", { key: "split-button-default" }, /* @__PURE__ */ React.createElement(DropdownButton, { bsSize: "xsmall", id: "forwarder-item", title: "Choose action", bsStyle: "default", pullRight: true }, /* @__PURE__ */ React.createElement(MenuItem, { href: ForwarderRoutes.details(id), eventKey: "1" }, "View"), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "forwarders:delete" }, /* @__PURE__ */ React.createElement(MenuItem, { eventKey: "2", onClick: _openRemoveConfirmation }, "Remove configuration"))), " ")), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showForwarderDeleteModal,
      title: "Delete forwarder",
      onConfirm: _onDelete,
      onCancel: _closeConfirmation
    },
    `Are you sure you want to delete forwarder "${title}"? This will remove all inputs running on this forwarder.`
  ), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showRemoveConfigModal,
      title: "Remove configuration",
      onConfirm: _onRemoveConfiguration,
      onCancel: _closeRemoveConfirmation
    },
    `Are you sure you want to remove the configuration of forwarder "${title}"? This will remove all inputs running on this forwarder.`
  )));
};
export default ForwarderEntry;
